import React, { useState } from 'react';
import PortfolioPage from '../../components/PortfolioPage';
import MainImage from '../../images/portfolio/AlienPlanets/episode_1.jpg';
import Progress_1 from '../../images/portfolio/AlienPlanets/CharacterSheetsProff.jpg';
import Progress_2 from '../../images/portfolio/AlienPlanets/InnsideAvSkipet.jpg';
import Progress_3 from '../../images/portfolio/AlienPlanets/StoryBoard.jpg';
import AlienPlanetsDescription from '../../components/AlienPlanetsDescription';
const PortfolioAlienPlanets = () => {
    return <PortfolioPage img={MainImage} url="https://player.vimeo.com/video/558730103" title="Alien Planets" description={<AlienPlanetsDescription />}>
         <div className="flex  mt-32 lg:px-0">
            <div className="max-w-sm">
              <img src={Progress_3} />
              
            </div>
          </div>

          <div className="flex flex-wrap  mt-32 justify-between">
          <img src={Progress_2} style={{maxHeight: "300px"}} />
          <img src={Progress_1}  style={{maxHeight: "300px"}}  />
          </div>

    </PortfolioPage>

}

export default PortfolioAlienPlanets;